const isRelativeURL = /^\/(?:[^/]|$)/;
const absoluteURLPrefix = /^https?:\/\/[^/]*/;
import { breakpoints } from './enums';
import { useBreakpoints } from '@ux/component-utilities';
import addhoc from 'addhoc';

/**
 * Determine if an item is active, or if any of it's children are active.
 *
 * @param {Object} item nav item
 * @param {String} currentHref the current url in the browser
 * @param {Boolean} [recurse=true] flag to enable recursion of children
 * @returns {Boolean} whether item is active
 * @private
 */
export function isActive(item, currentHref, recurse) {
  if (typeof (item.active) === 'boolean') return item.active;

  if (item.href && item.href === currentHref) return true;

  // Handle relative URLs
  if (currentHref && isRelativeURL.test(item.href) && item.href === currentHref.replace(absoluteURLPrefix, '')) {
    return true;
  }

  if (recurse !== false && item.children) {
    return item.children.some(child => isActive(child, currentHref));
  }

  return false;
}

export const withBreakpoints = addhoc(getWrappedComponent => {
  const { breakpoint } = useBreakpoints(...breakpoints);
  return getWrappedComponent({ breakpoint });
}, 'WithBreakpoints');

/**
 * Used to create a deep merge between two nested object
 * @param {Object} obj1 the fist object is used as the base the new object
 * @param {Object} obj2  the second object is used to override the obj1
 * @returns {Object} a new object with merge the props between both params.
 */
export function deepMerge(obj1, obj2) {
  const result = { ...obj1 };

  for (const key in obj2) {
    if (obj2[key] instanceof Object && obj1[key] instanceof Object) {
      result[key] = deepMerge(obj1[key], obj2[key]);
    } else {
      result[key] = obj2[key];
    }
  }

  return result;
}
